import { useDispatch, useSelector } from "react-redux";
import { fieldsToCheckTermite } from "../../../data/permitFormsData";
import FinancialBPModal from "../FinancialBPModal";
import React from "react";
import { setBuildingState } from "../../../store/actions/permitFormActions/buildingStateActions";

const AddingNewTermiteModal = () => {
  const { addingNewTermite } = useSelector((state) => state.buildingState);

  const dispatch = useDispatch();

  return (
    <FinancialBPModal
      type="termite"
      open={addingNewTermite}
      title={"Add New Termite Information"}
      handleStateNo={() => {
        dispatch(setBuildingState({ addingNewTermite: false }));
      }}
      fieldsToCheck={fieldsToCheckTermite}
    />
  );
};

export default React.memo(AddingNewTermiteModal);

